import { object, string } from "yup";

const validationSchema = object().shape({
  comments: string().required("You must enter a Comment"),
});

export default () => validationSchema;
